// extracted by mini-css-extract-plugin
export default {"title":"Email_title__xwKfP","description":"Email_description__jGEYp"};